import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { errorHandler, getContent } from '../../util/responseUtil';
import { CheckPermissionComponent } from '../../util/permission';
import {
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE,
    TICKET_LIST_MEMBER_VIEW,
    TICKET_LIST_NEW_CSO_VIEW,
    TICKET_LIST_NEW_MANAGER_VIEW,
    TICKET_LIST_SOLUTION_VIEW
} from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import ActionType from '../../redux/reducer/globalActionType';
import IconAttachment from '../../assets/icons/IconAttachment';
import IconEyeBlue from '../../assets/icons/IconEyeBlue';
import IconDownloadBlue from '../../assets/icons/IconDownloadBlue';
import IconAttachmentPicture from '../../assets/icons/IconAttachmentPicture';
import NoImage from '../../assets/images/no-image.png'
import Alert from '../Alert/Alert';

class TicketAttachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAttachmentModal: false,
            showDetailAttachmentModal: false,
            attachment: [],
            imageUrl: '',
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListAttachmentTicket = () => {
        // Ticket All
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                API_TICKET_LIST.getListAttachmentTicketCSO(this.props.data.id, this.props.token)
                    .then(res => {
                        if (this._isMounted) {
                            this.setState({
                                attachment: getContent(res)
                            })
                        }
                    }).catch(errorHandler(this.props.handleLogout, this.props.history))
            } else {
                // Non CSO
                API_TICKET_LIST.getListAttachmentTicketNonCSO(this.props.data.id, this.props.token)
                    .then(res => {
                        if (this._isMounted) {
                            this.setState({
                                attachment: getContent(res)
                            })
                        }
                    }).catch(errorHandler(this.props.handleLogout, this.props.history))
            }
        }
        // Ticket New
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) {
            API_TICKET_LIST.getListAttachmentTicketNew(this.props.data.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            attachment: getContent(res)
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
        // Ticket Member
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)) {
            API_TICKET_LIST.getListAttachmentTicketMember(this.props.data.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            attachment: getContent(res)
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
        // Ticket Solution
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            API_TICKET_LIST.getListAttachmentTicketSolution(this.props.data.id, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            attachment: getContent(res)
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
    }

    handleDownloadAttachment = e => {
        fetch(e.target.href, {
            method: "GET",
            headers: {}
        }).then(response => {
            response.arrayBuffer().then(function (buffer) {
                const url = window.URL.createObjectURL(new Blob([buffer]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "image.png"); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        })
    }

    handleShowAttachmentModal = () => {
        this.setState({ showAttachmentModal: !this.state.showAttachmentModal })
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentDidUpdate(prevProps) {
        if (this.props.data.id !== prevProps.data.id) {
            this.getListAttachmentTicket();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_VIEW, TICKET_LIST_ALL_VIEW_ASSIGNEE, TICKET_LIST_NEW_CSO_VIEW, TICKET_LIST_NEW_MANAGER_VIEW, TICKET_LIST_MEMBER_VIEW, TICKET_LIST_SOLUTION_VIEW]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btnattachment" className="bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1 relative" onClick={() => this.handleShowAttachmentModal()}>
                    <IconAttachment />
                    <span className="mx-1">Lampiran File</span>
                    {this.state.attachment.length > 0 && <div className="bg-red-500 h-2 w-2 2xl:h-3 2xl:w-3 rounded-full absolute -top-1 -right-1" />}
                </button>

                <div className={this.state.showAttachmentModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/2">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btncloseattachment" onClick={() => this.setState({ showAttachmentModal: false })} />
                            </div>
                            <p className="text-darkblue text-center text-3xl font-medium">Lampiran File</p>
                            {
                                this.state.attachment.length === 0
                                    ? <div className="flex justify-center items-center">
                                        <div className="text-center">
                                            <img
                                                src={this.state.imageUrl === '' ? NoImage : this.state.imageUrl}
                                                alt="attachment file"
                                                className="w-full h-full"
                                            />
                                            <p className="text-gray-700 text-2xl font-medium">Tidak ada lampiran</p>
                                        </div>
                                    </div>
                                    : <div className="flex mt-5">
                                        <div className="w-3/12 flex justify-center items-center border border-gray">
                                            <img
                                                src={this.state.imageUrl === '' ? NoImage : this.state.imageUrl}
                                                alt="attachment file"
                                                className={this.state.imageUrl === '' ? 'w-40 h-40' : 'object-cover w-full h-full'}
                                            />
                                        </div>
                                        <div className="w-9/12 pl-5 text-sm">
                                            {
                                                this.state.attachment.map((attachment, idx) =>
                                                    <div
                                                        className="flex justify-between items-center bg-blue-100 rounded-xl mb-2 px-5 py-3"
                                                        id="btnattachmentselect"
                                                        onClick={() => this.setState({ imageUrl: attachment.link })}
                                                        key={idx}
                                                    >
                                                        <div className="flex items-center w-1/2">
                                                            <IconAttachmentPicture />
                                                            <span className="mx-2 text-gray-700 truncate" title={attachment.link.split("/")[attachment.link.split("/").length - 1]}>{attachment.link.split("/")[attachment.link.split("/").length - 1]}</span>
                                                            {/* <span className="ml-2 text-gray-600">5mb</span> */}
                                                        </div>
                                                        <div className="text-darkblue font-medium flex items-center">
                                                            <div
                                                                className="mr-2 flex items-center cursor-pointer"
                                                                id="btnattachmentdetail"
                                                                onClick={() => this.setState({ showDetailAttachmentModal: true, imageUrl: attachment.link })}
                                                            >
                                                                <IconEyeBlue />
                                                                <span className="ml-2">Lihat</span>
                                                            </div>
                                                            <a
                                                                href={attachment.link}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                download
                                                                id="btnattahcmentdownload"
                                                                className="ml-2 flex items-center cursor-pointer"
                                                            // onClick={e => this.handleDownloadAttachment(e)}
                                                            >
                                                                <IconDownloadBlue />
                                                                <span className="ml-2">Unduh File</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                            }
                            <div className="flex justify-center items-center">
                                <button type="button" id="btnback" className="bg-lightblue rounded text-white focus:outline-none px-10 py-2 mt-3" onClick={() => this.setState({ showAttachmentModal: false })}>Kembali</button>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>

                <div className={this.state.showDetailAttachmentModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 max-w-5xl overflow-auto" style={{ maxHeight: "80%" }}>
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btncloseattachmentdetail" onClick={() => this.setState({ showDetailAttachmentModal: false })} />
                            </div>
                            <p className="text-darkblue text-center text-3xl font-medium">Detail Lampiran</p>
                            <img
                                src={this.state.imageUrl}
                                alt="attachment file"
                                className="object-cover h-full w-full mt-5"
                            />
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketAttachment);